import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { ConnectBackendService } from './connect-backend.service';
import { async } from '@angular/core/testing';
import { SettingSystemModel } from '../models/setting-system';

const PADDING = '000000';

@Injectable({
  providedIn: 'root'
})

export class UtityService {
  delimiter: string | undefined;
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  setting: SettingSystemModel | null;
  private paymentChannels: any[] =  [];
  constructor(
    private snackbar: MatSnackBar,
    public dialog: MatDialog,
    private service: ConnectBackendService,
    private http: HttpClient
  ) {
    this.DECIMAL_SEPARATOR = '.';
    this.THOUSANDS_SEPARATOR = ',';
    this.setting = null;
  } 

  async paymentChannel() {
    const payments = localStorage.getItem('paymentChannels');
    if(payments != null)
      return JSON.parse(payments);
    
    return await this.onLoadPaymentChannel();
  }

  async channels() {
    const channels = localStorage.getItem('channels');
    if(channels != null)
      return JSON.parse(channels);
    
    return await this.onLoadChannel();
  }

  async onLoadPaymentChannel() {
    const $payments =  this.http.get(`${this.service.url}/settings/payment`)
    this.paymentChannels = await lastValueFrom<any>($payments);
    localStorage.setItem('paymentChannels', JSON.stringify(this.paymentChannels))
    return this.paymentChannels;
  }

  async onLoadChannel() {
    
    const $channels =  this.http.get(`${this.service.url}/settings/chanel/`)
    const channels = await lastValueFrom<any>($channels);
    localStorage.setItem('channels', JSON.stringify( channels))
    return  channels;
  }

  async onLoadSettings() {
    
  }

 async swalConfirmSave(title?: string, text?: string): Promise<boolean>
  {
     const confirm = await Swal.fire({
      icon: 'warning',
      title: title === undefined ? 'ยืนยันทึกข้อมูล' : title,
      text: text === undefined ? '' : text,
      confirmButtonText: 'บันทึก',
      cancelButtonText: 'ยกเลิก',
      showCancelButton: true,
      showConfirmButton: true
    });

     if (confirm.isConfirmed)
     {
       return true;
     }

     return false;
  }

  getDelimiter(){
    return this.http.get(`${this.service.url}/getstart/getDelimiter/` , this.service.getHeadersAut());
  }


  bubble_sort(data: any){
    let temp = [];
    const n = data.length;

    for (let i = 0; i < n; i++){
        for (let j = 0; j < n - i - 1; j++){
            if ( data[j].id < data[j + 1].id){
                // swap the elements
                temp = data[j];
                data[j] = data[j + 1];
                data[j + 1] = temp;
            }
        }
    }

    return data;
  }

  play_audio(){
    const audio = new Audio('http://www.pingpongsoft.com/beep.wav');
    audio.play();
  }


  transform(value: number | string, fractionSize: number = 2): string {
    let [ integer, fraction = '' ] = (value || 0).toString()
      .split(this.DECIMAL_SEPARATOR);

    fraction = fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
      : '';

    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

    return integer + fraction;
  }

  parse(value: string, fractionSize: number = 2): string {
    let [ integer, fraction = '' ] = (value || '').split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, 'g'), '');

    fraction = parseInt(fraction, 10) > 0 && fractionSize > 0
      ? this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
      : '';

    return integer + fraction;
  }

  swalSuccess(): void {
    Swal.fire({
      title: `ทำรายการสำเร็จ`,
      text: '',
      icon: 'success',
      timer: 3000,
      showCancelButton: false,
    });
  }

  swal_delete_Success(): void {
    Swal.fire({
      title: `ลบรายการเรียบร้อย`,
      text: '',
      icon: 'success',
      timer: 3000,
      showCancelButton: false,
    });
  }

  swalSaveSuccess(): void {
    Swal.fire({
      title: `Saved !`,
      text: ' บันทึกข้อมูลสำเร็จ',
      icon: 'success',
      timer: 3000,
      showCancelButton: false,
    });
  }

  swal_warn(text): void {
    Swal.fire({
      title: `แจ้งเตือน`,
      text: `${text}`,
      icon: 'warning',
      timer: 3000,
      showCancelButton: false,
    });
  }

 

  expriDate(): void {
    let num_expire = Number(localStorage.getItem("num_expire"))
    if(num_expire <= 3 ){
      Swal.fire({
        title: `วันใช้งานใกล้หมดอายุ !!`,
        text: `กรุณาต่ออายุวันใช้งาน`,
        icon: 'error',
        // timer: 5000,
        showCancelButton: false,
      });
    }
    
  }

  swal_err(text): void {
    Swal.fire({
      title: `แจ้งเตือน`,
      text: `${text}`,
      icon: 'error',
      timer: 3000,
      showCancelButton: false,
    });
  }

  swalUnSuccess(): void {
    Swal.fire({
      title: `ทำรายการไม่สำเร็จ`,
      text: 'โปรดทำการลองใหม่อีกครั้งหรือ ติดต่อเจ้าหน้าที่เพื่อทำการตรวจสอบ',
      icon: 'error',
      showCancelButton: false,
    });
  }

  delimiter_string(): string | null {
    return localStorage.getItem('delimiter');
  }
  delimiter_qty_string(): string | null{
    return localStorage.getItem('delimiter_qty');
  }


  open_snackbar_error(msg){
      this.snackbar.openFromComponent(SnackbarComponent, this.option_error(msg));
  }

  open_snackbar_success(msg){
    this.snackbar.openFromComponent(SnackbarComponent, this.option_success(msg));
  }

  open_snackbar_warning(msg){
    this.snackbar.openFromComponent(SnackbarComponent, this.option_warinig(msg));
  }

  option_error(msg): any{
    return {

          duration: 2000,
          horizontalPosition: 'end',
          data: {msg},
          panelClass: ['snack-error'],

    };
  }

  option_success(msg): any{
    return {

          duration: 2000,
          horizontalPosition: 'end',
          data: {msg},
          panelClass: ['snack-success'],

    };
  }

  tabel(): string{
    return 'table table-hover table-borderless';
  }

  table_responsive(): string{
    return 'table-responsive';
  }
  
  option_warinig(msg): any{
    return {

          duration: 2000,
          horizontalPosition: 'end',
          data: {msg},
          panelClass: ['snack-warning'],

    };
  }
  open_dialog(component, _width, data, position): any{
    return this.dialog.open(component, this.option_dialog(_width, data, position));
  }


  option_dialog(_width, data, position): any{
    return {
        width: _width,
        data,
        autoFocus: false,
        position,
    };
  }

}
